import { Outlet } from 'react-router-dom';

const Subjects = () => {
  return <Outlet />;
};

export default Subjects;
